import { render, staticRenderFns } from "./GamesPlayed.vue?vue&type=template&id=018511ae&scoped=true&"
import script from "./GamesPlayed.vue?vue&type=script&lang=js&"
export * from "./GamesPlayed.vue?vue&type=script&lang=js&"
import style0 from "./GamesPlayed.vue?vue&type=style&index=0&id=018511ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018511ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDataTable,VIcon})
